import { Component, OnInit, Input, ViewChild, OnChanges } from "@angular/core";

import { Output, EventEmitter } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import {
  faGrid,
  faList,
  faArrowDownAZ,
  faArrowUpZA,
} from "@fortawesome/pro-light-svg-icons";
import {
  faSearch,
  faRotate,
  faEmptySet,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faCertificate,
  faShieldKeyhole,
} from "@fortawesome/pro-light-svg-icons";
import { CommonService } from "@services/common.service";
import { environment } from "../../../../environments/environment";

import { SelectionModel } from "@angular/cdk/collections";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortable } from "@angular/material/sort";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import { ImportDialogComponent } from "@dialogs/import/import.component";

import { AlertDialogComponent } from "@dialogs/alert/alert.component";
@Component({
    selector: "app-cms-list",
    templateUrl: "./cms-list.component.html",
    styleUrls: ["./cms-list.component.scss"],
    standalone: false
})
export class CMSListComponent implements OnInit, OnChanges {
  public canvasForm!: UntypedFormGroup;

  constructor(
    public commonService: CommonService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog
  ) {}
  @Input() toggleRefresh?: any;

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort!: MatSort;
  @Output() selectionList = new EventEmitter<string>();

  public canvas_listing: any[] = [];

  public p: number = 1;
  public breakpoint: number = 4;
  public display_data: string = "list";
  public status: boolean = true;
  public filtered_reports: any;
  public sort_view_asc: boolean = true;
  public pagination: any;

  public totalCanvasObjectResults: number = 0;
  public canvasListLoaded = false;

  public selectedReports: any = null;
  public selectedDashboards: any = null;
  public selectedBuilds: any = null;

  faList = faList;
  faGrid = faGrid;

  faSearch = faSearch;
  faCertificate = faCertificate;
  faShieldKeyhole = faShieldKeyhole;
  faArrowDownAZ = faArrowDownAZ;
  faArrowUpZA = faArrowUpZA;
  faRotate = faRotate;
  faEmptySet = faEmptySet;
  public direction = false;

  public fieldForm!: UntypedFormGroup;
  public error: string = "";
  public page: number = 1;
  public count: number = 20000;
  public dataFields: any[] = [];
  public canvasFields: any[] = [];
  public fieldItem: any;
  public disableButtons = false;
  public loading = false;

  showData = false;
  showRefresh = false;
  disableRefresh = false;
  displayedColumns: string[] = [
    "select",
    "name",
    "product",
    "category",
    "status",
    "sync",
    "lastImport",
  ];
  dataSetListing: any;
  existingDataFields: any;
  dataSource: any;
  selection = new SelectionModel<any>(true, []);
  filterValues: any = {};

  timer: any;
  firstTime = true;
  public data: any = [];

  getAllBuilds() {
    this.commonService.getAllBuilds().subscribe((data: any) => {
      this.canvasListLoaded = true;
      this.data = data.data;

      this.dataSource = new MatTableDataSource(<any>data.data);
      this.selection = new SelectionModel<any>(true, []);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.showData = true;
      this.showRefresh = true;
    });
  }

  refreshBuilds() {
    this.dataSource = [];
    this.showData = false;
    this.canvasListLoaded = false;
    this.disableRefresh = true;
    this.commonService.refreshBuilds().subscribe((data: any) => {
      this.canvasListLoaded = true;
      this.data = data.data;

      this.dataSource = new MatTableDataSource(<any>data.data);
      this.selection = new SelectionModel<any>(true, []);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.showData = true;
      this.disableRefresh = false;
    });
  }
  formatModified(time: string) {
    if (!time) return "";
    const displaydTIme = dayjs(time).format("MMM D YYYY - h:MM A");
    return displaydTIme;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.selection.clear();

    // this.isAllSelected()
    //   ? this.selection.clear()
    //   : this.dataSource.data.forEach((row: any) => this.selection.select(row));
  }

  logSelection() {
    this.selection.selected.forEach((s: any) => console.log(s.id));
  }

  applyFilter(filter: any) {
    const filterValue = (filter.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openImportDialog(enabled: boolean): void {
    this.toggleRefresh = null;
    setTimeout(() => {
      this.selectedBuilds = this.selection.selected;

      let selectedBuildsFiltered = this.selectedBuilds;

      let buildData: any[] = [];

      selectedBuildsFiltered.forEach((element: any) => {
        let data = {
          buildName: element.build,
          productUuid: element.productUuid,
        };
        buildData.push(data);
      });

      if (buildData.length <= 0) {
        let action = "disabled";
        if (enabled) action = "enabled";
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          data: {
            message: "There are no builds selected that can be " + action + ".",
            detail:
              "All selected builds and prodcuts already have the CMS Import set to " +
              action +
              ".",
          },
          panelClass: "canvas-dialog",
        });
      } else {
        let message = "Disable ";
        if (enabled) message = "Enable ";

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          disableClose: true,
          data: {
            message:
              message +
              " the CMS Import on these " +
              this.selection.selected.length +
              " builds?",
            actionButton: "Confirm",
          },
          panelClass: "canvas-dialog",
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            const formBody = { enable: enabled, builds: buildData };
            this.commonService.toggleBuilds(formBody).subscribe((data: any) => {
              this.modifyEnabled(enabled, this.selection.selected);
            });
          }
        });
      }
    }, 200);
  }

  openCMSImportDialog(): void {
    this.toggleRefresh = null;
    this.disableButtons = true;
    this.loading = true;
    setTimeout(() => {
      this.selectedBuilds = this.selection.selected;

      let selectedBuildsFiltered = this.selectedBuilds;
      let buildData: any[] = [];

      selectedBuildsFiltered.forEach((element: any) => {
        let data = {
          name: element.build,
          category_id: element.category_id,
        };
        buildData.push(data);
      });

      const formBody = { builds: buildData };
      this.commonService.CMSImportBuilds(formBody).subscribe((data: any) => {
        this.loading = false;
        const dialogRef = this.dialog.open(ImportDialogComponent, {
          disableClose: true,
          width: "50%",
          data: {
            message: "These are the canvases that will be published.",
            actionButton: "Confirm",
            canvasData: data.data,
            status: false,
          },
          panelClass: "canvas-dialog",
        });

        dialogRef.afterClosed().subscribe((result) => {
          this.disableButtons = false;
          if (result) {
            this.loading = true;
            const formBody = { builds: buildData };
            this.commonService
              .CMSImportBuildsApply(formBody)
              .subscribe((data: any) => {
                this.loading = false;
                const status = "Pending";
                this.modifyStatus(this.selection.selected, status);
              });
          }
        });
      });
    }, 200);
  }

  openSyncStatusDialog(
    event: Event,
    categoryName: string,
    buildName: string,
    categoryId: number
  ): void {
    event.stopPropagation();
    this.toggleRefresh = null;
    this.disableButtons = true;

    this.loading = true;
    setTimeout(() => {
      this.selection.clear();
      this.commonService
        .getCanvasImports(buildName, categoryId)
        .subscribe(({ data }: any) => {
          this.loading = false;
          const dialogRef = this.dialog.open(ImportDialogComponent, {
            disableClose: false,
            width: "75%",
            data: {
              message:
                "Import Canvas Status for " + buildName + " - " + categoryName,
              actionButton: "Confirm",
              canvasData: data,
              status: true,
            },
            panelClass: "canvas-dialog",
          });

          dialogRef.afterClosed().subscribe((result) => {
            this.disableButtons = false;
          });
        });
    }, 200);
  }

  modifyEnabled(enabled: boolean, selection: any) {
    selection.forEach((element: any) => {
      element.cmsEnabled = enabled;
    });

    this.selection.clear();
  }

  modifyStatus(selection: any, status: string) {
    selection.forEach((element: any) => {
      element.lastImportStatus = status;
    });

    this.selection.clear();
  }

  ngOnChanges() {}
  ngOnInit(): void {
    this.canvasForm = this.fb.group({
      searchTerm: new UntypedFormControl(),
    });
    this.getAllBuilds();
  }
}
